import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import download from 'downloadjs';

export default {
  name: 'DNF-Shipment-Report',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading,
    download
  },
  props: [],
  data() {
    return {
      ShipmentListArray: [],
      isLoading: false,
      fromdate: '',
      todate: '',
      pageCount: 0,
      pageNo: 0,
      limit: 100,
      totalRows: 0,
      shippingids: '',
      showList: false,
      locationLoading: '',
      location: 0,
      locationitem: {
        id: '',
        text: ''
      },
      locationdetailsarray: [],
      DestLocationNameData: [],
      LocationNameData: [],
      shipmentLimit: false,
      shipmentLimitMsg: '',
      showLogs: false,
      popUpname: '',
      APIResponse: '',
      csvFields: [],
      csvData: [],
      endDateRange: new Date(Date.now()),
      startDateRange: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
    }
  },
  computed: {},
  filters: {
    moment: function (date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
  mounted() {
    this.getLocationName();
  },
  methods: {
    getdate(date) {
      var today = new Date(date);
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      var today = yyyy + '-' + mm + '-' + dd;
      return today;
    },
    getShipmentList() {
      this.totalRows = 0
      this.ShipmentListArray = []
      this.showList = true
      this.isLoading = true
      var FromDate = this.getdate(this.fromdate)
      var ToDate = this.getdate(this.todate)
      let inputArray = [];
      let shippingIdArray = [];
      if (this.shippingids && this.shippingids.trim() != "") {
				if (/\r?\n|\r/g.test(this.shippingids) == true) {
					this.shippingids = this.shippingids.replace(/\r?\n|\r/g, ',');
				}
				if (/\s/g.test(this.shippingids) == true) {
					this.shippingids = this.shippingids.replace(/\n|"|'| |,\s*$/g, ',');
				}
				if (this.shippingids.indexOf(',') == -1) {
					shippingIdArray.push(this.shippingids);
				} else {
					shippingIdArray = this.shippingids.split(',');
				}
        this.shipmentLimit = false;
        this.shipmentLimitMsg = '';
        if (shippingIdArray.length > 1000) {
          this.isLoading = false;
          this.shipmentLimit = true;
          this.shipmentLimitMsg = "Please Enter Shipment's Upto 1000";
          return false;
        }
        for (let i = 0; i < shippingIdArray.length; i++) {
          if(shippingIdArray[i] && shippingIdArray[i] != ''){
            inputArray.push({ "ShippingId": shippingIdArray[i] })
          }
        }
      }
      let input = ({
        locationId: this.location,
        shippingids: inputArray,
        startDate: FromDate,
        endDate: ToDate,
        offset: this.pageNo,
        limit: this.limit
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'getShipmentListForDNF',
        'data': input,
        'headers': {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.ShipmentListArray = result.data.ResponseData;
            this.$alertify.success(result.data.ReturnMessage);
            this.totalRows = result.data.TotalCount
            if (this.totalRows < 100) {
              this.pageCount = 1
            } else {
              this.pageCount = Math.ceil(this.totalRows / 100);
            }
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          this.isLoading = false;
        })
    },
    getPaginationData(pageNum) {
      this.pageNo = 0
      this.pageNo = (pageNum - 1);
      this.getShipmentList();
    },
    onSubmit: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pageNo = 0
          this.$refs.paginate.selected = 0;
          this.getShipmentList()
        } else {
          console.log('errors exist', this.errors)
        }
      }).catch((err) => {
        console.log('errors exist', err)
      });
    },
    selectLocation(locationitem) {
      this.locationitem = locationitem
      this.location = locationitem.id
    },
    getLocationName() {
      this.locationLoading = 'Loading Location Names...'
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
        .then(result => {
          this.locationLoading = ''
          var LocationNameData = result.data.ResponseData
          this.locationdetailsarray = result.data.ResponseData
          for (i = 0; i < LocationNameData.length; i++) {
            this.DestLocationNameData.push({
              id: LocationNameData[i].HubID,
              text: LocationNameData[i].HubName + ' (' + LocationNameData[i].HubID + ')'
            })
            this.LocationNameData = this.DestLocationNameData
          }
        }, error => {
          console.error(error)
        })
    },
    reset() {
      this.ShipmentListArray = [],
      this.isLoading = false,
      this.fromdate = '',
      this.todate = '',
      this.pageCount = 0,
      this.pageNo = 0,
      this.totalRows = 0,
      this.shippingids = '',
      this.showList = false,
      this.locationLoading = '',
      this.location = 0,
      this.locationitem = [],
      this.locationdetailsarray = [],
      this.DestLocationNameData = [],
      this.LocationNameData = [],
      this.shipmentLimit = false,
      this.shipmentLimitMsg = '',
      this.showLogs = false,
      this.APIResponse = '',
      this.csvFields = [],
      this.csvData = [],
      this.$validator.reset()
    },
    closeWindow() {
      this.showLogs = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    getDNFAPIResponse(data) {
      this.popUpname = "DNF API Response";
      this.showLogs = true;
      this.APIResponse = data;
    },
    exportData() {
      if (this.fromdate && this.todate) {
        let inputArray = [];
        if (this.shippingids || this.shippingids != "") {
          this.shipmentLimit = false;
          this.shipmentLimitMsg = ''
          var shippingIdArray = this.shippingids.split(",");
          if (shippingIdArray.length > 1000) {
            this.shipmentLimit = true;
            this.shipmentLimitMsg = "Please Enter Shipment's Upto 1000"
            return false;
          }
          for (let i = 0; i < shippingIdArray.length; i++) {
            inputArray.push({ "ShippingId": shippingIdArray[i] })
          }
        }
        var FromDate = this.getdate(this.fromdate)
        var ToDate = this.getdate(this.todate)
        this.csvData = []
        this.isLoading = true;
        this.input = ({
          locationId: this.location,
          shippingids: inputArray,
          startDate: FromDate,
          endDate: ToDate
        });
        axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'getDNFShipmentDetailsToExport',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
          .then(result => {
            this.isLoading = false;
            if (result.data.ResultCode == 100) {
              this.csvData = result.data.ResponseData.map((e) => {
                return {
                  'ShippingID': e.ShippingID,
                  'Status': e.Status,
                  'ShipmentStatus': e.ShipmentStatus,
                  'ProcessLocation': e.ProcessLocation,
                  'ShipmentCurrentHubID': e.ShipmentCurrentHubID,
                  'RequestTime': e.RequestTime,
                  'Process': e.Process,
                  'APIResponse': e.DNFResponse.ReturnMessage
                }
              });
              this.csvFields = {
                'ShippingID': 'ShippingID',
                'Status': 'Status',
                'ShipmentStatus': 'ShipmentStatus',
                'ProcessLocation': 'ProcessLocation',
                'ShipmentCurrentHubID': 'ShipmentCurrentHubID',
                'RequestTime': 'RequestTime',
                'Process': 'Process',
                'APIResponse': 'APIResponse'
              }
              this.jsonToCSV('Report_', this.csvData, this.csvFields);
            } else {
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      } else {
        this.$alertify.error('Please select date range');
      }
    },
    jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
      var csvData = ''
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }
      //Fields
      for (let key in data[0]) {
        if (skipFilter.indexOf(key) == -1)
          csvData += csvfield[key] + ','
      }
      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
      //Data
      data.map(function (item) {
        for (let key in item) {
          if (skipFilter.indexOf(key) == -1) {
            var escapedCSV = item[key] + '' // cast Numbers to string
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilder.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
              else
                csvData += escapedCSV + ','
            }
          }
        }
        csvData = csvData.slice(0, csvData.length - 1)
        csvData += '\r\n'
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n')
      }
      filename += moment().format('DD-MM-YYYY') + '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData
    },
    export(data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
      this.$alertify.success("Successful")
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/DNFShipmentReport/DNFShipmentReport.js